import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';
import { FuitesPipe } from '../../../pipes/fuites.pipe';
import { FuitesStatutPipe } from '../../../pipes/fuites-statut.pipe';

@Component({
  selector: 'app-traitement-data-fuites-95',
  standalone: true,
  imports: [
    TraitementDataComponent,
    FuitesPipe,
    FuitesStatutPipe,
    ALaDateDuPipe
  ],
  templateUrl: './traitement-data-fuites-95.component.html',
  styleUrl: './traitement-data-fuites-95.component.scss',
})
export class TraitementDataFuites95Component {
  @Input() patient: Patient | undefined;
}